import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { Icon, Text, FlexContainer, Banner, Sizes } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TaxReturnTypes, textsByType } from 'Containers/Result/utils';
import FlexLiteBannerInfo from 'Containers/Result/components/FlexLiteBannerInfo';
import MandatoryInfo from 'Containers/Result/components/MandatoryInfo';
import { ResultType } from 'Types/common';
import IconAmount from '../IconAmount';
import FlexLiteInfoToPay from '../FlexLiteInfoToPay';
import { getApril30Info } from './utils';
import * as Styled from './styles';

const ResultInfo = ({
  data,
  isToPayLite,
}: {
  data: ResultType;
  isToPayLite: boolean;
}): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const { header, subheader, text, amountColor } = textsByType[data?.taxReturnType];

  const isToPay = data?.taxReturnType === TaxReturnTypes.TO_PAY;

  const getToPayTextContext =
    isToPay && getApril30Info().isAfterApril30 ? 'finishSeason' : isToPay ? 'endDays' : '';
  return (
    <>
      {isToPayLite && data.taxReturnType === TaxReturnTypes.TO_PAY ? (
        <FlexLiteInfoToPay data={data} />
      ) : (
        <>
          <Text type="paragraphs" align="center" size="L_XL_S" color="dark">
            {t(header)}
          </Text>
          <FlexContainer direction="column" align="center" justify="center" gap="dimension_08">
            <Text type="paragraphs" align="center" size="M_L_S" color="dark">
              {t(subheader)}
            </Text>
            {isToPayLite && (
              <Text type="paragraphs" size="L_L_S" color="dark">
                {YayoyakiFormatter.formatAmountMxn(Math.abs(data?.taxReturnResult))}
              </Text>
            )}
          </FlexContainer>
        </>
      )}
      {!isToPayLite && (
        <Styled.AmountContainer fullWidth align="center" justify="center" gap="dimension_16">
          {data.taxReturnType === TaxReturnTypes.TO_RETURN ? (
            <Icon icon="ShineL" color="warning" />
          ) : (
            <IconAmount type={data?.taxReturnType} />
          )}
          <Text type="headline" size="S_L_S" color={amountColor}>
            {YayoyakiFormatter.formatAmountMxn(Math.abs(data?.taxReturnResult))}
          </Text>
          {data.taxReturnType === TaxReturnTypes.TO_RETURN ? (
            <Icon icon="ShineL" color="warning" />
          ) : (
            <IconAmount type={data?.taxReturnType} />
          )}
        </Styled.AmountContainer>
      )}
      {isToPayLite && <FlexLiteBannerInfo data={data} />}
      {data?.mandatory && data?.taxReturnType !== TaxReturnTypes.TO_PAY ? (
        <MandatoryInfo daInfo={data} />
      ) : (
        data?.mandatory && (
          <Banner
            id="mandatory-info"
            mode="warning"
            hasIcon
            layout="embed"
            position="vertically"
            label={t('Result.mandatory.season.banner.title')}
            description={t('Result.mandatory.season.end.title', {
              context: getApril30Info().isAfterApril30 && 'finishSeason',
              day: getApril30Info().daysLeft,
            })}
            titleSize={Sizes.S}
            size={Sizes.M}
          />
        )
      )}
      {!isToPayLite && (
        <Text type="paragraphs" align="center" size="S_M_S" color="dark">
          {t(text, {
            context: getToPayTextContext,
          })}
        </Text>
      )}
    </>
  );
};

export default ResultInfo;
